import React from 'react'
import { FC, createContext, useContext, useState } from 'react'
import { getStorageAdapter, lpKey } from '@shell/adapters/storage'

interface LPContextProps {
  lpModule: number
  setLPModule: (module: number, userId: string, lpId?: string) => void
}

const LPContext = createContext<LPContextProps | undefined>(undefined)

export const getStoredSelectedModule = (userId: string, lpId = '') => {
  return Number(getStorageAdapter().get(lpKey(userId, lpId, 'selectedModule')) || 0)
}

const LPContextProvider: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [lpModule, setmodule] = useState(0)
  const setLPModule = (module: number, userId: string, lpId = '') => {
    getStorageAdapter().set(lpKey(userId, lpId, 'selectedModule'), String(module))
    setmodule(module)
  }
  return <LPContext.Provider value={{ lpModule, setLPModule }}>{children}</LPContext.Provider>
}

const useLPContext = () => {
  const context = useContext(LPContext)
  if (!context) {
    throw new Error('useLPContext must be used within a LPContextProvider')
  }
  return context
}

export { LPContextProvider, useLPContext }
